const whiteListedMerchants = [
  'https://paiinternational.in',
  'https://widget-test.instacred.dev',
  'https://widget-staging.instacred.dev',
];

const isMerchantUrlWhitelisted = (url) => {
  return whiteListedMerchants.includes(url);
};

const getWhitelistedUrl = (url) => {
  return whiteListedMerchants.find((whitelistedUrl) => whitelistedUrl === url);
};

export const isParentMerchantOriginValid = (postMessageOrigin) => {
  const parentMerchantOrigin = document.referrer;
  const isOriginValid = parentMerchantOrigin.includes(postMessageOrigin)
    ? true
    : isMerchantUrlWhitelisted(postMessageOrigin);

  return isOriginValid;
};

export const getValidParentMerchantUrl = (postMessageOrigin) => {
  const parentMerchantOrigin = document.referrer
    ? document.referrer
    : getWhitelistedUrl(postMessageOrigin);

  return parentMerchantOrigin;
};



// WEBPACK FOOTER //
// ./utils/merchantOriginHelper.js